module.exports = __webpack_public_path__ + "aw.7f503ec44d704b31cbe8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/aw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/aw.svg
// module chunks = styles